module.exports = __webpack_public_path__ + "static/media/gift03_zhChs.44677d60.png";